import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";


export class InstallationTarget extends JSONMapped() {
	constructor(data?: Partial<InstallationTarget>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	name: string;

	@jsonProperty()
	type: string;

	@jsonProperty()
	deviceID: number;

	@jsonProperty()
	cardSlotDescription: string;

	@jsonProperty()
	displayLRUName: string;

	@jsonProperty()
	comments: string;
}

export class JeppesenDatabaseUpdateSelection extends JSONMapped() {
	constructor(data?: Partial<JeppesenDatabaseUpdateSelection>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	jeppChartAuthorizedDeviceIDs: Array<number>;
}

export class GarminDatabaseUpdateSelection extends JSONMapped() {
	constructor(data?: Partial<GarminDatabaseUpdateSelection>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	seriesID: number;

	@jsonProperty()
	issueName: string;

	@jsonProperty()
	authorizedDeviceIDs: Array<number>;

	@jsonProperty()
	subregionIDs: Array<string>;
}

export class EnablementUpdateSelection extends JSONMapped() {
	constructor(data?: Partial<EnablementUpdateSelection>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty()
	enablementID: number;

	@jsonProperty()
	description: string;

	@jsonProperty()
	authorizedDeviceIDs: Array<number>;
}

export class UpdateSelection extends JSONMapped() {
	constructor(data?: Partial<UpdateSelection>) {
		super();
		Object.assign(this, data);
	}

	@jsonProperty(JSONMapper.classByMethods(InstallationTarget))
	installationTarget: InstallationTarget;

	@jsonProperty(JSONMapper.arrayOfClass(GarminDatabaseUpdateSelection))
	garminDatabases: Array<GarminDatabaseUpdateSelection>;

	@jsonProperty(JSONMapper.arrayOfClass(EnablementUpdateSelection))
	enablements: Array<EnablementUpdateSelection>;

	@jsonProperty(JSONMapper.classByMethods(JeppesenDatabaseUpdateSelection))
	jeppesenDatabases: JeppesenDatabaseUpdateSelection;
}
